module.exports = __webpack_public_path__ + "static/media/helix-hx8.25ecd6ee.png";